import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { LayoutContext, TutorialDialog } from '@/_shared/components';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';
import { SurveysIntro, UsefulInformation } from '../components';
import { useCurrentTemplate } from '../state';

export const SurveysScreen = () => {
  // eslint-disable-next-line @altermaind/use-translations-scope
  const t = useTranslations('surveys.tutorial');

  const { setLayout } = useContext(LayoutContext);
  const { openDialog: openDialogSurveysTutorial } = useDialog('surveysTutorial');

  const { isSoftSkillSurvey } = useCurrentTemplate();
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = isSoftSkillSurvey
    ? [
        {
          title: t('softSkills.slides.slide1.title'),
          description: t('softSkills.slides.slide1.description'),
          assetName: 'tutorialSurveysSoftSkillsSlide1',
        },
        {
          title: t('softSkills.slides.slide2.title'),
          description: t('softSkills.slides.slide2.description'),
          assetName: 'tutorialSurveysSoftSkillsSlide2',
        },
        {
          title: t('softSkills.slides.slide3.title'),
          description: t('softSkills.slides.slide3.description'),
          assetName: 'tutorialSurveysSoftSkillsSlide3',
        },
        {
          title: t('softSkills.slides.slide4.title'),
          description: t('softSkills.slides.slide4.description'),
          assetName: 'tutorialSurveysSoftSkillsSlide4',
        },
        {
          title: t('softSkills.slides.slide5.title'),
          description: t('softSkills.slides.slide5.description'),
          assetName: 'tutorialSurveysSoftSkillsSlide5',
        },
      ]
    : [
        {
          title: t('hardSkills.slides.slide1.title'),
          description: t('hardSkills.slides.slide1.description'),
          assetName: 'tutorialSurveysHardSkillsSlide1',
        },
        {
          title: t('hardSkills.slides.slide2.title'),
          description: t('hardSkills.slides.slide2.description'),
          assetName: 'tutorialSurveysHardSkillsSlide2',
        },
        {
          title: t('hardSkills.slides.slide3.title'),
          description: t('hardSkills.slides.slide3.description'),
          assetName: 'tutorialSurveysHardSkillsSlide3',
        },
        {
          title: t('hardSkills.slides.slide4.title'),
          description: t('hardSkills.slides.slide4.description'),
          assetName: 'tutorialSurveysHardSkillsSlide4',
        },
        {
          title: t('hardSkills.slides.slide5.title'),
          description: t('hardSkills.slides.slide5.description'),
          assetName: 'tutorialSurveysHardSkillsSlide5',
        },
      ];

  useEffect(() => {
    if (
      !hasAlreadySeenTutorial(
        isSoftSkillSurvey ? TutorialKeys.SurveysSoftSkill : TutorialKeys.SurveysHardSkills,
      )
    ) {
      openDialogSurveysTutorial();
    }
  }, [hasAlreadySeenTutorial, isSoftSkillSurvey, openDialogSurveysTutorial]);

  useEffect(() => {
    setLayout({ title: 'surveys' });
  }, [setLayout, t]);

  return (
    <Box>
      <SurveysIntro />
      <UsefulInformation />
      <TutorialDialog
        translationsKey={
          isSoftSkillSurvey ? 'surveys.tutorial.softSkills' : 'surveys.tutorial.hardSkills'
        }
        dialogKey='surveysTutorial'
        slides={slides}
      />
    </Box>
  );
};
